import { useState, useEffect } from 'react';
import { i18n } from '@ankr.com/common';

import { Locale } from 'modules/i18n/types/locale';
import { useLocale } from 'modules/i18n/utils/useLocale';

import { locales } from '../locales';

export const useInitializeLocale = () => {
  const [isInitialized, setIsInitialized] = useState<boolean>(false);
  const { locale } = useLocale();

  useEffect(() => {
    setIsInitialized(false);

    i18n
      .init({
        lng: locale,
        fallbackLng: Locale.en,
        interpolation: {
          escapeValue: false,
        },
        nsSeparator: ':::',
        returnObjects: true,
        resources: {
          en: {
            translation: locales[Locale.en],
          },
        },
      })
      .then(() => setIsInitialized(true));
  }, [locale]);

  return isInitialized;
};
